import { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import Logo from './Logo'
import resume from '../../assets/FarazResume.pdf'
const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])
  const fileUrl = resume;
  const fileName = 'Faraz Resume'

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            I'm a very ambitious Software engineer looking for a role in an
            established IT company with the opportunity to work with the latest
            technologies on challenging and diverse projects.
          </p>
          <p align="LEFT">
            I'm quiet confident, naturally curious, and perpetually working on
            improving my skills in Software design and development.
          </p>
          <p>
            If I need to define myself in one sentence that would be a highly
            professional, technology enthusiast and a video game fanatic!!!
          </p>
          <p>
            Check out my resume by clicking on this <span><a href={fileUrl} download={fileName}>link</a></span>
          </p>
        </div>
        <Logo/>
        
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
